import { AudienceApi } from 'shared/api/requests/audience'
import { Body, McAPI } from 'utils/api/types'

import {
  IAudienceAPI,
  IContactMergeCompareResponse,
  ISubscribersDetailsResponse,
} from '../types/api'

export const makeMergeSubscribersAPI = (api: McAPI): IAudienceAPI => ({
  async searchSubscribers(query: string) {
    const response = await AudienceApi.search({ body: { q: query } })

    return response.data.users
  },
  async getDetailsSubscribers(userId: string) {
    const response = await api.get<ISubscribersDetailsResponse & Body>(
      '/:currentAccountID/subscribers/details?user_id=:id'.replace(':id', userId),
    )

    return response.user
  },
  async getContactMergeCompare(userId, secondaryId, conflictResolve) {
    const response = await api.post<IContactMergeCompareResponse & Body>(
      '/:currentAccountID/contactMerge/compare',
      {
        body: {
          target_id: userId,
          source_id: secondaryId,
          conflict_resolve: conflictResolve,
        },
      },
    )

    return response
  },
  async mergeContacts(userId, secondaryId, conflictResolve) {
    const response = await api.post<{ state: true } & Body>(
      '/:currentAccountID/contactMerge/merge',
      {
        body: { target_id: userId, source_id: secondaryId, conflict_resolve: conflictResolve },
      },
    )

    return response.state
  },
})
